//index.js
import Repository from '../../../repositories/RepositoryFactory';
const StaffRepository = Repository.get('staffs');

// Filtering the staff list is live, so the user can start a new search before the previous one
// has come back. Responses are not guaranteed to arrive in the order they were sent, and a slow
// early response landing last would put results on screen that do not match what was typed.
// Only the newest request is allowed to commit.
let latestStaffsRequestId = 0;

export default {
  postStaff: async ({ commit }, { staff, regAuth }) => {
    var response = await StaffRepository.createStaff(staff, regAuth);
    commit('POST_staff', response.data.result);
  },
  updateStaff: async ({ commit }, { staff }) => {
    var response = await StaffRepository.updateStaff(staff);
    commit('PUT_staff', response.data.result);
  },

  getStaffs: async (
    { commit },
    {
      lazyParams,
      searchFilterbyOutlet,
      searchFilterbyContact,
      searchFilterbyPosition,
      searchFilterbyUserName,
    },
  ) => {
    const requestId = ++latestStaffsRequestId;

    var response = await StaffRepository.getStaffs(
      lazyParams,
      searchFilterbyOutlet,
      searchFilterbyContact,
      searchFilterbyPosition,
      searchFilterbyUserName,
    );

    if (requestId !== latestStaffsRequestId) {
      return;
    }

    // AxiosClient resolves transport failures as { error }, so there is no data to commit.
    // Leaving the previous rows on screen beats blanking the table on a dropped request.
    if (!response || response.error || !response.data) {
      throw new Error(
        'Could not load staffs. Please check your connection and try again.',
      );
    }

    commit('SET_staffs', response.data.result);
  },

  getCounterGroups: async ({ commit }, { lazyParams }) => {
    var response = await StaffRepository.getCounterGroups(lazyParams);
    commit('SET_counterGroups', response.data.result);
  },
  postCounterGroup: async ({ commit }, { counterGroup }) => {
    var response = await StaffRepository.createCounterGroup(counterGroup);
    // var response2 = await StaffRepository.getCounters();
    // commit("SET_counters", response2.data.result);
    // commit("SET_counterGroups", response.data.result);
    // We dont use this because of can't find a consistent algotithm to alter state.counters with new changes
    commit('POST_counterGroup', response.data.result);
  },
  updateCounterGroup: async (
    { commit },
    { counterGroup, lazyParamsCounterGroups },
  ) => {
    var response = await StaffRepository.updateCounterGroup(
      counterGroup,
      lazyParamsCounterGroups,
    );
    // var response2 = await StaffRepository.getCounters();
    // commit("SET_counters", response2.data.result);
    commit('SET_counterGroups', response.data.result);
    // We dont use this because of can't find a consistent algotithm to alter state.counters with new changes
    // commit("PUT_counterGroup", response.data.result);
  },

  getOutlets: async ({ commit }) => {
    var response = await StaffRepository.getOutlets();
    commit('SET_outlets', response.data.result);
  },
  postOutlet: async ({ commit }, { outlet }) => {
    var response = await StaffRepository.createOutlet(outlet);
    commit('POST_outlet', response.data.result);
  },
  updateOutlet: async ({ commit }, { outlet, lazyParamsCounterGroups }) => {
    var response = await StaffRepository.updateOutlet(outlet);
    // var response2 = await StaffRepository.getCounters();
    var response3 = await StaffRepository.getCounterGroups(
      lazyParamsCounterGroups,
    );
    commit('PUT_outlet', response.data.result);
    // commit("SET_counters", response2.data.result);
    commit('SET_counterGroups', response3.data.result);
  },

  getCounters: async ({ commit }, payload) => {
    var response = await StaffRepository.getCounters(payload);
    commit('SET_counters', response.data.result);
  },
  getOrganizations: async ({ commit }) => {
    var response = await StaffRepository.getOrganizations();
    commit('SET_organizations', response.data.result);
  },
  getStaffPositions: async ({ commit }) => {
    var response = await StaffRepository.getStaffPositions();
    commit('SET_staffPositions', response.data.result);
  },
  getWalkinServiceTypes: async ({ commit }) => {
    var response = await StaffRepository.getWalkinServiceTypes();
    commit('SET_walkinServiceTypes', response.data.result);
  },
  getOutletsOnly: async ({ commit }, payload) => {
    var response = await StaffRepository.getOutletsOnly(payload);
    commit('SET_outletsOnly', response.data.result);
  },
};
